import { useEffect, useState } from "react";
import html2pdf from 'html2pdf.js';

export default function useGeneratePdf() {
    const [pdfProject, setPdfProject] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [pdfTitle, setPdfTitle] = useState("teaser");

    const generatePDF = async (project, title) => {
        setPdfProject(project); // Establecemos el proyecto actual
        setIsGenerating(true);   // Indicamos que estamos generando el PDF
        setPdfTitle(title || project?.fakeTitle || project?.title || "teaser");
    };

    useEffect(() => {
        if (!pdfProject) return;

        const timeout = setTimeout(() => {
            const container = document.getElementById('teaser-template');
            const teaserTemplate = container?.children?.[0];
            if (!teaserTemplate) {
                setIsGenerating(false);
                setPdfProject(null);
                return;
            }
            
            const titlePdf = (pdfTitle || "teaser")?.toLowerCase().replaceAll("p******* ", "project").replaceAll(" ", "-");

            const opt = {
                margin: 0,
                filename: `${titlePdf}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: false,
                    logging: false,
                },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            };

            html2pdf().set(opt).from(teaserTemplate).save().then(() => {
                setIsGenerating(false);
                setPdfProject(null);
            }).catch((error) => {
                console.error("Error generating PDF:", error);
                setIsGenerating(false);
                setPdfProject(null);
            });
        }, 500); // Aumentado el timeout para dar tiempo a que se renderice

        return () => clearTimeout(timeout);
    }, [pdfProject, pdfTitle]);

    return { pdfProject, isGenerating, generatePDF };
}

